import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Section Components
import HeroSection from "./components/sections/HeroSection";
import PersonasSection from "./components/sections/PersonasSection";
import ProblemsSection from "./components/sections/ProblemsSection";
import SolutionSection from "./components/sections/SolutionSection";
import BenefitsSection from "./components/sections/BenefitsSection";
import PlansSection from "./components/sections/PlansSection";
import FAQSection from "./components/sections/FAQSection";

// REMOVIDO: TestimonialsSection (será adicionado futuramente com depoimentos reais)
// REMOVIDO: ContactSection (CTAs apenas nos planos)
// REMOVIDO: FloatingCTA (CTAs apenas nos planos)

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <PersonasSection />
        <ProblemsSection />
        <SolutionSection />
        <BenefitsSection />
        <PlansSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
